import { render, staticRenderFns } from "./ElectricPotentialViz.vue?vue&type=template&id=09784062&scoped=true"
import script from "./ElectricPotentialViz.vue?vue&type=script&lang=js"
export * from "./ElectricPotentialViz.vue?vue&type=script&lang=js"
import style0 from "./ElectricPotentialViz.vue?vue&type=style&index=0&id=09784062&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09784062",
  null
  
)

export default component.exports